import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const fmtDate = (v) => (v ? dayjs(v).format("D MMM YYYY") : "—");
export const fmtDateTime = (v) => (v ? dayjs(v).format("D MMM, HH:mm") : "—");
export const fmtRel = (v) => (v ? dayjs(v).fromNow() : "—");
export const fmtMoney = (v, c = "$") => (v == null ? "—" : `${c}${Number(v).toFixed(2)}`);
export const isOverdue = (v) => v && dayjs(v).isBefore(dayjs());
export const titleCase = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());

export const REC_LABEL = { contact_now: "Contact now", research_first: "Research first", nurture: "Nurture", not_suitable: "Not suitable" };
export const REC_CLASS = { contact_now: "chip-info", research_first: "chip-warning", nurture: "chip-nurture", not_suitable: "chip-danger" };
export const EVIDENCE_CLASS = { confirmed: "chip-success", possible: "chip-warning", unknown: "chip-muted" };
export const STATUS_CLASS = { prospect: "chip-muted", engaged: "chip-info", qualified: "chip-success", customer: "chip-success", nurture: "chip-nurture", not_suitable: "chip-danger" };
export const STAGE_LABEL = { discovery: "Discovery", qualified: "Qualified", proposal: "Proposal", negotiation: "Negotiation", won: "Won", lost: "Lost" };
export const RUN_STATUS_CLASS = { queued: "chip-muted", running: "chip-info", completed: "chip-success", cancelled: "chip-muted", failed: "chip-danger", stopped_budget: "chip-warning" };
